('use-client');

import React from 'react';
import HamburgerOpenButtonCommon from '../../HamburgerOpenButton';
import type {
  IStylableButtonImperativeActions,
  IStylableButtonProps,
} from '../../../../../StylableButton/StylableButton.types';
import styles from './HamburgerOpenButton.scss';
import StylableButton from '../../../../../StylableButton/viewer/skinComps/StylableButton/StylableButton.skin';

const HamburgerOpenButtonSkin: React.ForwardRefRenderFunction<
  IStylableButtonImperativeActions,
  IStylableButtonProps
> = props => {
  const extendedProps = {
    ...props,
    classes: {
      ...styles,
      hamburgerOpenButtonRoot: styles.root,
    },
    StylableButton,
  };
  return <HamburgerOpenButtonCommon {...extendedProps} />;
};

export default React.forwardRef(HamburgerOpenButtonSkin);
